module.exports = __webpack_public_path__ + "fonts/NunitoSans_7pt-ExtraLightItalic.2a86fcf7.ttf";